import { render, staticRenderFns } from "./ForPaper.vue?vue&type=template&id=17859b98&"
import script from "./ForPaper.vue?vue&type=script&lang=js&"
export * from "./ForPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports